<template>
  <div class="mb-3">
    <h2 class="fw-light d-flex align-items-center mb-0">
      <router-link
        to="/documents/suppliers"
        class="d-flex align-items-center me-2"
        title="Voltar"
      >
        <i class="ph-caret-circle-left ph-2x" />
      </router-link>
      Detalhes do Fornecedor
    </h2>
  </div>
  <LoadingData v-if="isLoading" />
  <div
    v-else
    class="card card-body border-start border-start-width-2 border-start-primary"
  >
    <SupplierDocuments
      :supplier="supplier"
      :documents="documents"
      @getSupplierDocuments="getSupplierDocuments"
    />
  </div>
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import SupplierDocuments from '@/components/documents/suppliers/SupplierDocuments.vue'

export default {
  name: 'SupplierDetails',

  components: {
    LoadingData,
    SupplierDocuments,
  },

  data() {
    return {
      cgccfo: this.$route.params.cgccfo,
      isLoading: true,
      supplier: null,
      documents: [],
    }
  },

  methods: {
    async getSupplier() {
      try {
        this.supplier = await this.$store.dispatch('getSupplier', this.cgccfo)
        this.getSupplierDocuments()
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async getSupplierDocuments() {
      try {
        this.documents = await this.$store.dispatch(
          'getSupplierDocuments',
          this.cgccfo,
        )

        this.isLoading = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  mounted() {
    this.getSupplier()
  },
}
</script>
